<template>
  <v-row class="custom-grey-border" :class="{ 'ml-0': !vShowCalendar }">
    <v-col
      md="12"
      class="light-gray-background custom-border-bottom d-flex align-center justify-space-between py-3 px-4"
    >
      <div class="d-flex align-center">
        <v-icon color="cyan darken-2" class="mr-2"
          >mdi-account-group-outline</v-icon
        >
        <span
          class="text-uppercase font-weight-700 color-custom-blue font-size-16 tracking-wide"
        >
          Team
        </span>
        <v-chip
          small
          color="cyan darken-1"
          class="ml-2 font-weight-700 white--text elevation-1"
          style="height: 22px; min-width: 26px; justify-content: center"
        >
          {{ assignedTeam?.length || 0 }}
        </v-chip>
      </div>

      <div>
        <v-btn
          v-if="availableTeam.length"
          class="custom-bold-button white--text text-capitalize elevation-0"
          color="cyan darken-1"
          small
          depressed
          @click="show_engineers = true"
        >
          <v-icon left small>mdi-account-plus</v-icon>Assign Team
        </v-btn>
        <v-btn
          v-else
          class="custom-bold-button white--text text-capitalize elevation-0"
          color="cyan darken-1"
          small
          v-on:click="getEngineers()"
          depressed
          :loading="jobLoading"
          :disabled="jobLoading"
        >
          <v-icon left small>mdi-sync</v-icon>Get Available
        </v-btn>
      </div>
    </v-col>
    <v-col md="12" class="pa-3">
      <v-row>
        <v-col v-if="assignedTeamObject.length > 0" md="12" class="pa-0">
          <div
            v-for="(row, index) in assignedTeamObject"
            :key="index"
            class="assigned-member-card d-flex align-center justify-space-between p-3 mb-2 rounded border background-white"
            :class="{ 'is-team-lead': row.mark_as_tl }"
          >
            <div class="d-flex align-center">
              <v-avatar size="42" class="mr-3 avatar-shadow">
                <v-img
                  :lazy-src="$defaultProfileImage"
                  :src="row.engineer_profile_logo || $defaultProfileImage"
                ></v-img>
              </v-avatar>
              <div>
                <div class="d-flex align-center flex-wrap">
                  <span
                    class="font-weight-600 font-size-15 color-custom-blue mr-2"
                  >
                    {{ row.engineer_display_name }}
                  </span>
                  <template v-if="row.mark_as_tl">
                    <v-chip
                      label
                      x-small
                      color="blue darken-1"
                      class="white--text font-weight-700 px-2 shadow-xs"
                    >
                      <v-icon x-small left class="white--text mr-1"
                        >mdi-crown</v-icon
                      >
                      Team Lead
                    </v-chip>
                  </template>
                </div>
                <div v-if="row.engineer_designation" class="mt-1">
                  <v-chip
                    label
                    color="red lighten-5"
                    text-color="red darken-2"
                    x-small
                    class="font-weight-600 border-red-light"
                  >
                    {{ row?.engineer_designation }}
                  </v-chip>
                </div>
              </div>
            </div>
            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    v-on:click="removeEngineer(row.engineer_id)"
                    icon
                    small
                    class="remove-btn"
                  >
                    <v-icon small color="red lighten-1"
                      >mdi-close-circle-outline</v-icon
                    >
                  </v-btn>
                </template>
                <span>Remove from team</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col v-else md="12" class="py-6 text-center">
          <div class="empty-team-state pa-4 rounded border-dashed">
            <v-avatar size="48" color="cyan lighten-5" class="mb-3">
              <v-icon color="cyan darken-2" medium
                >mdi-account-group-outline</v-icon
              >
            </v-avatar>
            <div
              class="font-size-15 font-weight-600 grey--text text--darken-2 mb-1"
            >
              No Team Members Assigned
            </div>
            <p class="font-size-13 grey--text mb-3">
              Assign engineers to handle this schedule visit or task.
            </p>
            <v-btn
              small
              outlined
              color="cyan darken-1"
              class="text-capitalize font-weight-600"
              @click="
                availableTeam.length ? (show_engineers = true) : getEngineers()
              "
            >
              <v-icon left small>mdi-account-plus-outline</v-icon>
              {{
                availableTeam.length
                  ? "Assign Now"
                  : "Fetch Available Engineers"
              }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <Dialog :common-dialog="show_engineers" :dialog-width="950">
      <template v-slot:title>
        <div class="d-flex align-center">
          <v-icon color="cyan darken-2" class="mr-2"
            >mdi-account-multiple-check</v-icon
          >
          <span>Select Team Members</span>
          <v-chip
            small
            color="cyan lighten-5"
            text-color="cyan darken-3"
            class="ml-3 font-weight-700"
          >
            {{ draftAssignedTeam?.length || 0 }} Selected
          </v-chip>
        </div>
      </template>
      <template v-slot:body>
        <v-container fluid class="py-2 px-1">
          <v-row>
            <v-col md="12" class="pt-0 pb-2">
              <div
                class="d-flex flex-wrap align-center justify-space-between gap-2"
              >
                <v-text-field
                  style="max-width: 280px"
                  v-model.trim="search"
                  v-on:click:clear="(search = null), filterData()"
                  clearable
                  dense
                  flat
                  solo
                  outlined
                  hide-details
                  placeholder="Search engineers..."
                  prepend-inner-icon="mdi-magnify"
                  color="cyan"
                  class="mr-2 bg-white"
                  @keydown.enter="filterData()"
                  @keydown.tab="filterData()"
                ></v-text-field>
                <v-autocomplete
                  hide-details
                  v-model.trim="type"
                  class="mr-2 bg-white"
                  :items="typeList"
                  dense
                  flat
                  solo
                  outlined
                  style="max-width: 180px"
                  placeholder="Type"
                  prepend-inner-icon="mdi-filter-variant"
                  item-color="cyan"
                  color="cyan"
                  @change="getRelatedSkill()"
                  item-value="value"
                  item-text="text"
                >
                </v-autocomplete>
                <v-autocomplete
                  hide-details
                  v-model.trim="related_text"
                  class="mr-2 bg-white"
                  :items="skillList"
                  dense
                  flat
                  solo
                  outlined
                  style="max-width: 240px"
                  placeholder="Filter Skill/Category"
                  prepend-inner-icon="mdi-certificate-outline"
                  item-color="cyan"
                  color="cyan"
                  clearable
                  v-on:click:clear="clearType()"
                  @change="filterData()"
                  item-value="text"
                  item-text="text"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title class="grey--text"
                        >No Category(s) Found.</v-list-item-title
                      >
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item }">
                    <div class="d-flex align-center">
                      <span
                        v-if="item.color"
                        class="color-dot mr-2"
                        :style="{ backgroundColor: item.color }"
                      ></span>
                      <span
                        class="text-capitalize font-weight-500 font-size-14"
                        >{{ item.text }}</span
                      >
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div class="d-flex align-center py-1">
                      <span
                        v-if="item.color"
                        class="color-dot mr-2"
                        :style="{ backgroundColor: item.color }"
                      ></span>
                      <span
                        class="text-capitalize font-weight-500 font-size-14"
                        >{{ item.text }}</span
                      >
                    </div>
                  </template>
                </v-autocomplete>
              </div>
            </v-col>
            <v-col md="12" class="pt-0 custom-listing-table">
              <v-simple-table
                class="inner-simple-table engineer-table rounded border"
                fixed-header
              >
                <template v-slot:default>
                  <thead>
                    <tr class="custom-border-bottom table-header-style">
                      <th
                        class="font-size-16 font-weight-700 px-3 py-0"
                        width="40"
                      >
                        Select
                      </th>
                      <th class="font-size-16 font-weight-700 px-3 py-0">
                        Engineer Name
                      </th>
                      <th class="font-size-16 font-weight-700 px-3 py-0">
                        Role
                      </th>
                      <th class="font-size-16 font-weight-700 px-3 py-0">
                        Skills
                      </th>
                      <th class="font-size-16 font-weight-700 px-3 py-0">
                        Certificates
                      </th>
                      <th class="font-size-16 font-weight-700 px-3 py-0">
                        Licenses
                      </th>
                      <th
                        class="font-size-16 font-weight-700 px-3 py-0"
                        width="90"
                      >
                        Mark As TL
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="lodash.isEmpty(availableTeam) === false">
                      <tr
                        v-for="row in availableTeam"
                        :key="row.engineer_id + '-' + draftAssignedTeam.length"
                        class="table-row-hover"
                        :class="{
                          'selected-row': draftAssignedTeam.includes(
                            row.engineer_id
                          ),
                        }"
                      >
                        <td class="px-2 text-center">
                          <v-checkbox
                            :input-value="draftAssignedTeam"
                            :placeholder="row.engineer_display_name"
                            :value="row.engineer_id"
                            :disabled="row?.engineer_disabled == 1"
                            hide-details
                            color="cyan darken-1"
                            class="ma-0 justify-center"
                            v-on:change="toggleEngineer(row, $event)"
                            multiple
                          ></v-checkbox>
                        </td>
                        <td class="px-3 py-2">
                          <div class="d-flex align-center">
                            <v-avatar size="36" class="mr-2 border-shadow">
                              <v-img
                                class="white-background"
                                width="36"
                                height="36"
                                :lazy-src="$defaultProfileImage"
                                :src="
                                  row.engineer_profile_logo ||
                                  $defaultProfileImage
                                "
                              ></v-img>
                            </v-avatar>
                            <div>
                              <div class="d-flex align-center">
                                <span
                                  class="font-weight-600 text-capitalize color-custom-blue font-size-14"
                                >
                                  {{ row?.engineer_display_name }}
                                </span>
                                <v-chip
                                  v-if="row?.engineer_disabled == 1"
                                  label
                                  x-small
                                  color="red lighten-5"
                                  text-color="red darken-2"
                                  class="ml-2 font-weight-600"
                                >
                                  Unavailable
                                </v-chip>
                              </div>
                              <div
                                v-if="row?.engineer_designation"
                                class="mt-1"
                              >
                                <v-chip
                                  label
                                  color="grey lighten-4"
                                  text-color="grey darken-2"
                                  x-small
                                  style="font-size: 10px; height: 18px"
                                >
                                  {{ row?.engineer_designation }}
                                </v-chip>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="px-3 py-2">
                          <span
                            v-if="row && row.engineer_role == 2"
                            class="font-weight-500 grey--text text--darken-2 font-size-13"
                          >
                            Technician
                          </span>
                          <span v-else class="grey--text font-size-13">-</span>
                        </td>
                        <td class="px-3 py-2">
                          <template v-if="row?.all_skills?.length > 0">
                            <div class="d-flex flex-wrap gap-1">
                              <v-chip
                                v-if="row?.all_skills[0]?.certificate_name"
                                x-small
                                :color="
                                  row?.all_skills[0]?.color || 'cyan lighten-5'
                                "
                                label
                                :text-color="
                                  row?.all_skills[0]?.color
                                    ? 'white'
                                    : 'cyan darken-3'
                                "
                                class="font-weight-500"
                              >
                                {{ row?.all_skills[0]?.certificate_name }}
                              </v-chip>
                              <v-chip
                                v-if="row?.all_skills[1]?.certificate_name"
                                x-small
                                :color="
                                  row?.all_skills[1]?.color || 'cyan lighten-5'
                                "
                                label
                                :text-color="
                                  row?.all_skills[1]?.color
                                    ? 'white'
                                    : 'cyan darken-3'
                                "
                                class="font-weight-500"
                              >
                                {{ row?.all_skills[1]?.certificate_name }}
                              </v-chip>
                              <v-chip
                                v-if="row?.all_skills?.length > 2"
                                x-small
                                color="blue lighten-5"
                                text-color="blue darken-3"
                                label
                                class="font-weight-600"
                              >
                                +{{ row?.all_skills?.length - 2 }} More
                              </v-chip>
                            </div>
                          </template>
                          <span
                            v-else
                            class="text-muted font-size-12 font-italic"
                            >No skills</span
                          >
                        </td>
                        <td class="px-3 py-2">
                          <template v-if="row?.all_certificates?.length > 0">
                            <div class="d-flex flex-wrap gap-1">
                              <v-chip
                                v-if="
                                  row?.all_certificates[0]?.certificate_name
                                "
                                x-small
                                :color="
                                  row?.all_certificates[0]?.color ||
                                  'purple lighten-5'
                                "
                                label
                                :text-color="
                                  row?.all_certificates[0]?.color
                                    ? 'white'
                                    : 'purple darken-3'
                                "
                                class="font-weight-500"
                              >
                                {{ row?.all_certificates[0]?.certificate_name }}
                              </v-chip>
                              <v-chip
                                v-if="
                                  row?.all_certificates[1]?.certificate_name
                                "
                                x-small
                                :color="
                                  row?.all_certificates[1]?.color ||
                                  'purple lighten-5'
                                "
                                label
                                :text-color="
                                  row?.all_certificates[1]?.color
                                    ? 'white'
                                    : 'purple darken-3'
                                "
                                class="font-weight-500"
                              >
                                {{ row?.all_certificates[1]?.certificate_name }}
                              </v-chip>
                              <v-chip
                                v-if="row?.all_certificates?.length > 2"
                                x-small
                                color="blue lighten-5"
                                text-color="blue darken-3"
                                label
                                class="font-weight-600"
                              >
                                +{{ row?.all_certificates?.length - 2 }} More
                              </v-chip>
                            </div>
                          </template>
                          <span
                            v-else
                            class="text-muted font-size-12 font-italic"
                            >No certificates</span
                          >
                        </td>
                        <td class="px-3 py-2">
                          <template v-if="row?.all_licenses?.length > 0">
                            <div class="d-flex flex-wrap gap-1">
                              <v-chip
                                v-if="row?.all_licenses[0]?.certificate_name"
                                x-small
                                :color="
                                  row?.all_licenses[0]?.color ||
                                  'teal lighten-5'
                                "
                                label
                                :text-color="
                                  row?.all_licenses[0]?.color
                                    ? 'white'
                                    : 'teal darken-3'
                                "
                                class="font-weight-500"
                              >
                                {{ row?.all_licenses[0]?.certificate_name }}
                              </v-chip>
                              <v-chip
                                v-if="row?.all_licenses[1]?.certificate_name"
                                x-small
                                :color="
                                  row?.all_licenses[1]?.color ||
                                  'teal lighten-5'
                                "
                                label
                                :text-color="
                                  row?.all_licenses[1]?.color
                                    ? 'white'
                                    : 'teal darken-3'
                                "
                                class="font-weight-500"
                              >
                                {{ row?.all_licenses[1]?.certificate_name }}
                              </v-chip>
                              <v-chip
                                v-if="row?.all_licenses?.length > 2"
                                x-small
                                color="blue lighten-5"
                                text-color="blue darken-3"
                                label
                                class="font-weight-600"
                              >
                                +{{ row?.all_licenses?.length - 2 }} More
                              </v-chip>
                            </div>
                          </template>
                          <span
                            v-else
                            class="text-muted font-size-12 font-italic"
                            >No licenses</span
                          >
                        </td>
                        <td class="px-2 text-center" width="90">
                          <v-checkbox
                            :disabled="checkDisabled(row.engineer_id)"
                            color="blue darken-1"
                            hide-details
                            class="ma-0 justify-center"
                            small
                            :value="isTeamLead(row)"
                            :input-value="isTeamLead(row)"
                            :true-value="true"
                            :false-value="false"
                            v-on:change="toggleTeamLead(row, $event)"
                          ></v-checkbox>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="7" class="py-8 text-center">
                          <v-icon color="grey lighten-1" large class="mb-2"
                            >mdi-account-search-outline</v-icon
                          >
                          <p
                            class="m-0 grey--text text--darken-1 font-weight-500 font-size-15"
                          >
                            Sorry! No team members found matching your search.
                          </p>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="closeEngineer()"
        >
          <v-icon left small>mdi-close</v-icon>
          Cancel
        </v-btn>
        <v-btn
          class="custom-bold-button ml-4"
          depressed
          @click="handleSave"
          color="cyan white--text"
          >Save</v-btn
        >
      </template>
    </Dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { GET } from "@/core/services/store/request.module";
import {
  REMOVE_ENGINEER,
  GET_AVAILABLE_ENGINEER,
  UPDATE_SCHEDULE_STATE,
  UPDATE_SCHEDULE_ENGINEER,
} from "@/core/services/store/job.module";

import { ErrorEventBus } from "@/core/lib/message.lib";

import moment from "moment-timezone";
import Dialog from "@/view/pages/partials/Dialog.vue";
// import { GET_TICKET } from "@/core/services/store/job.module";
import { find, cloneDeep } from "lodash";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "job-ctx-schedule-team",
  props: {
    selectedCustomer: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      show_engineers: false,
      visitId: 0,
      ticketId: 0,
      search: null,
      type: "all",
      related_text: null,
      skillList: [],
      typeList: [
        { value: "all", text: "All" },
        { value: "skill", text: "Skill" },
        { value: "certificate", text: "Certificate" },
        { value: "license", text: "Licences" },
      ],
      originalAssignedTeam: [],
      originalAssignedTeamObject: [],
      /** Staged (unsaved) selection – written to the store only on Save. */
      draftAssignedTeam: [],
      draftAssignedTeamObject: [],
      checkScheduleTimeout: null,
    };
  },
  watch: {
    show_engineers(val) {
      if (val) {
        this.search = null;
        this.type = "all";
        this.related_text = null;
        this.getRelatedSkill();

        this.seedDrafts();

        // Refresh the roster and PRUNE the saved team: engineers that come back as unavailable (or are no longer in the roster) are removed
        const refresh = this.getEngineers(true);
        if (refresh === false) {
          if (
            this.scheduleType === "recurring" &&
            !(this.scheduleOutput && this.scheduleOutput.length)
          ) {
            ErrorEventBus.$emit(
              "update:error",
              "Please create the schedule before proceeding."
            );
          }
        } else if (refresh && typeof refresh.then === "function") {
          refresh
            .catch(() => {
              // A failed refresh must never block the dialog from opening.
            })
            .then(() => {
              this.dropUnavailableFromDrafts();
              this.originalAssignedTeam = [...this.assignedTeam];
              this.originalAssignedTeamObject = JSON.parse(
                JSON.stringify(this.assignedTeamObject)
              );
            });
        }
      }
    },
    scheduleWatchKey(newVal, oldVal) {
      if (newVal && oldVal && newVal !== oldVal) {
        clearTimeout(this.checkScheduleTimeout);
        this.checkScheduleTimeout = setTimeout(() => {
          this.validateAssignedEngineersForSchedule();
        }, 400);
      }
    },
  },
  methods: {
    clearType() {
      this.related_text = null;
      this.type = "all";
      this.filterData();
      this.getRelatedSkill();
    },
    handleSave() {
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbAssignedTeam",
        value: [...this.draftAssignedTeam],
      });
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbAssignedTeamObject",
        value: cloneDeep(this.draftAssignedTeamObject),
      });
      this.resetFilters();
      this.show_engineers = false;
    },
    resetFilters() {
      this.search = null;
      this.type = "all";
      this.related_text = null;
    },
    seedDrafts() {
      this.originalAssignedTeam = [...this.assignedTeam];
      this.originalAssignedTeamObject = JSON.parse(
        JSON.stringify(this.assignedTeamObject)
      );
      this.draftAssignedTeam = [...this.assignedTeam];
      this.draftAssignedTeamObject = JSON.parse(
        JSON.stringify(this.assignedTeamObject)
      );
    },
    dropUnavailableFromDrafts() {
      const roster = this.availableTeam || [];
      const unavailableIds = new Set(
        roster
          .filter(
            (row) =>
              row && row.engineer_id && Number(row.engineer_disabled) === 1
          )
          .map((row) => row.engineer_id)
      );
      if (!unavailableIds.size) {
        return;
      }
      this.draftAssignedTeam = (this.draftAssignedTeam || []).filter(
        (id) => !unavailableIds.has(id)
      );
      this.draftAssignedTeamObject = (
        this.draftAssignedTeamObject || []
      ).filter((row) => !unavailableIds.has(row.engineer_id));
    },
    checkDisabled(id) {
      if (find(this.draftAssignedTeam, (row) => row == id)) {
        return false;
      }
      return true;
    },
    toggleEngineer(row, value) {
      const engineerId = row?.engineer_id;
      if (engineerId === undefined || engineerId === null) {
        return;
      }
      const isChecked = Array.isArray(value)
        ? value.some((id) => id == engineerId)
        : !!value;
      const isFirstSelection = !this.draftAssignedTeam.length && isChecked;
      const wasTeamLead = !!find(
        this.draftAssignedTeamObject,
        (obj) => obj.engineer_id == engineerId && obj.mark_as_tl
      );

      if (isChecked) {
        if (!this.draftAssignedTeam.includes(engineerId)) {
          this.draftAssignedTeam.push(engineerId);
        }
        if (!find(this.draftAssignedTeamObject, { engineer_id: engineerId })) {
          this.draftAssignedTeamObject.push({
            ...cloneDeep(row),
            mark_as_tl: !!row?.mark_as_tl,
          });
        }
        if (isFirstSelection) {
          const firstTechnician = find(
            this.draftAssignedTeamObject,
            (r) => r.engineer_id == engineerId && r.engineer_role == 2
          );
          if (firstTechnician) {
            this.draftAssignedTeamObject.forEach((obj) => {
              obj.mark_as_tl =
                obj.engineer_id == firstTechnician.engineer_id;
            });
          }
        }
        return;
      }

      this.draftAssignedTeam = this.draftAssignedTeam.filter(
        (id) => id != engineerId
      );
      this.draftAssignedTeamObject = this.draftAssignedTeamObject.filter(
        (obj) => obj.engineer_id != engineerId
      );
      if (wasTeamLead) {
        this.draftAssignedTeamObject.forEach((obj) => {
          obj.mark_as_tl = false;
        });
      }
    },
    toggleTeamLead(row, value) {
      const flagValue = Array.isArray(value) ? value.length > 0 : !!value;
      this.draftAssignedTeamObject.forEach((obj) => {
        obj.mark_as_tl =
          obj.engineer_id == row.engineer_id ? flagValue : false;
      });
    },
    isTeamLead(row) {
      const assigned = find(this.draftAssignedTeamObject, {
        engineer_id: row?.engineer_id,
      });
      return !!assigned?.mark_as_tl;
    },
    // closeEngineer() {
    //   if (this.visitId > 0) {
    //     let key = "dbAssignedTeam";
    //     let value = this.assignedTeam;
    //     let statekey = "dbAssignedTeamObject";
    //     let stateValue = this.assignedTeamObject;
    //     /* console.log(this.assignedTeam,'assignedTeam')
    //   console.log(this.assignedTeamObject,'assignedTeamObject') */
    //     this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
    //     this.$store.commit(UPDATE_SCHEDULE_STATE, { statekey, stateValue });
    //     this.$store.commit(UPDATE_SCHEDULE_ENGINEER);
    //     this.show_engineers = false;
    //   } else {
    //     let key = "dbAssignedTeam";
    //     let value = [];
    //     let statekey = "dbAssignedTeamObject";
    //     let stateValue = [];
    //     this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
    //     this.$store.commit(UPDATE_SCHEDULE_STATE, { statekey, stateValue });
    //     this.$store.commit(UPDATE_SCHEDULE_ENGINEER);
    //     this.show_engineers = false;
    //   }
    // },

    closeEngineer() {
      this.draftAssignedTeam = [...this.originalAssignedTeam];
      this.draftAssignedTeamObject = JSON.parse(
        JSON.stringify(this.originalAssignedTeamObject)
      );
      this.resetFilters();
      this.show_engineers = false;
    },
    updateScheduleState(key, value) {
      const isFirstSelection =
        this.assignedTeam.length === 0 && value && value.length === 1;
      const unselectedTeamLead = find(
        this.assignedTeamObject,
        (row) => row.mark_as_tl && !value.some((id) => id == row.engineer_id)
      );

      this.teamUpdate = true;
      this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
      this.$store.commit(UPDATE_SCHEDULE_ENGINEER);

      if (isFirstSelection) {
        const firstTechnician = find(
          this.assignedTeamObject,
          (row) => row.engineer_id == value[0] && row.engineer_role == 2
        );

        if (firstTechnician) {
          this.updateAssignedTeamObject(firstTechnician, true);
        }
      } else if (unselectedTeamLead) {
        this.updateAssignedTeamObject(unselectedTeamLead, false);
      }
    },
    updateAssignedTeamObject(value, event) {
      const flagValue = !!event;
      if (this.assignedTeamObject && this.assignedTeamObject.length > 0) {
        this.assignedTeamObject.forEach((obj) => {
          if (obj.engineer_id == value.engineer_id) {
            obj.mark_as_tl = flagValue;
          } else if (flagValue) {
            obj.mark_as_tl = false;
          }
        });
      }
      if (this.availableTeam && this.availableTeam.length > 0) {
        this.availableTeam.forEach((obj) => {
          if (obj.engineer_id == value.engineer_id) {
            obj.mark_as_tl = flagValue;
          } else if (flagValue) {
            obj.mark_as_tl = false;
          }
        });
      }
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbAssignedTeamObject",
        value: this.assignedTeamObject,
      });
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbAvailableTeam",
        value: this.availableTeam,
      });
    },
    // updateAssignedTeamObject(value, event) {
    //   let flagValue = false;
    //   if (event) {
    //     flagValue = true;
    //   }
    //   if (this.assignedTeamObject && this.assignedTeamObject.length > 0) {
    //     for (let i = this.assignedTeamObject?.length - 1; i >= 0; i--) {
    //       if (this.assignedTeamObject[i].engineer_id == value.engineer_id) {
    //         (this.assignedTeamObject[i].mark_as_tl = flagValue),
    //           (this.availableTeam[i].mark_as_tl = flagValue);
    //       } else {
    //         this.availableTeam[i].mark_as_tl = false;
    //         this.assignedTeamObject[i].mark_as_tl = false;
    //       }
    //     }
    //   }
    //   if (this.availableTeam && this.availableTeam.length > 0) {
    //     for (let i = this.availableTeam?.length - 1; i >= 0; i--) {
    //       if (this.availableTeam[i].engineer_id == value.engineer_id) {
    //         this.availableTeam[i].mark_as_tl = flagValue;
    //       } else {
    //         this.availableTeam[i].mark_as_tl = false;
    //       }
    //     }
    //   }
    //   let statekey = "dbAssignedTeamObject";
    //   this.$store.commit(UPDATE_SCHEDULE_STATE, { statekey, value });
    // },

    removeEngineer(id) {
      this.$store.commit(REMOVE_ENGINEER, id);
    },
    filterData() {
      // if (this.visitId > 0) {
      //   this.$store.dispatch(GET_TICKET, {
      //     ticket: this.ticketId,
      //     visit: this.visitId,
      //     /*   search: this.search ? this.search : "",
      //     related_text: this.related_text ? this.related_text : "",
      //     type: this.type ? this.type : "", */
      //   });
      // } else {
      //   this.getEngineers();
      // }
      this.getEngineers();
    },
    getRelatedSkill() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: `related-skill/${this.type}`,
        })
        .then(({ data }) => {
          _this.skillList = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    validateAssignedEngineersForSchedule() {
      if (!this.assignedTeam || !this.assignedTeam.length) {
        return;
      }
      this.getEngineers(true);
    },
    filterUnavailableAssignedEngineers(engineersList) {
      const list = Array.isArray(engineersList)
        ? engineersList
        : this.availableTeam || [];
      const availableIds = new Set();

      list.forEach((row) => {
        if (row && row.engineer_id && Number(row.engineer_disabled) !== 1) {
          availableIds.add(row.engineer_id);
        }
      });

      // Filter assignedTeam to only keep those available
      const newAssignedTeam = (this.assignedTeam || []).filter((id) =>
        availableIds.has(id)
      );

      // Filter assignedTeamObject to only keep those available
      const newAssignedTeamObject = (this.assignedTeamObject || []).filter(
        (row) => availableIds.has(row.engineer_id)
      );

      // Commit changes to vuex store
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbAssignedTeam",
        value: newAssignedTeam,
      });
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbAssignedTeamObject",
        value: newAssignedTeamObject,
      });
      this.$store.commit(UPDATE_SCHEDULE_ENGINEER);
    },
    getEngineers(isScheduleChange = false) {
      let schedule = new Object();

      if (this.scheduleType == "one-off") {
        schedule = this.oneOffSchedule;
      }

      if (this.scheduleType == "recurring") {
        if (this.scheduleOutput.length == 0) {
          if (!isScheduleChange) {
            ErrorEventBus.$emit(
              "update:error",
              "Please create the schedule before proceeding."
            );
          }
          return false;
        }
        // Normalize a copy for the availability request. Do not add the
        // snake_case aliases to the reactive schedule row that is submitted.
        schedule = { ...this.scheduleOutput[0] };

        schedule.start_date = schedule.startDate || schedule.start_date;
        schedule.start_time = schedule.startTime || schedule.start_time;
        schedule.end_date = schedule.endDate || schedule.end_date;
        schedule.end_time = schedule.endTime || schedule.end_time;
      }

      if (
        !schedule.start_date ||
        !schedule.start_time ||
        !schedule.end_date ||
        !schedule.end_time
      ) {
        return false;
      }

      const startDateTime = moment(
        `${schedule.start_date} ${schedule.start_time}`,
        ["YYYY-MM-DD hh:mm A", "YYYY-MM-DD h:mm A", "YYYY-MM-DD HH:mm"]
      );
      const endDateTime = moment(`${schedule.end_date} ${schedule.end_time}`, [
        "YYYY-MM-DD hh:mm A",
        "YYYY-MM-DD h:mm A",
        "YYYY-MM-DD HH:mm",
      ]);

      if (
        !startDateTime.isValid() ||
        !endDateTime.isValid() ||
        !endDateTime.isAfter(startDateTime)
      ) {
        return false;
      }

      return this.$store
        .dispatch(GET_AVAILABLE_ENGINEER, {
          search: this.search,
          customer: this.selectedCustomer,
          related_text: this.related_text ? this.related_text : "",
          type: this.type ? this.type : "",
          start_date: startDateTime.format("YYYY-MM-DD"),
          start_time: startDateTime.format("HH:mm"),
          end_date: endDateTime.format("YYYY-MM-DD"),
          end_time: endDateTime.format("HH:mm"),
          force: this.visitId && this.visitId > 0 ? 1 : 0,
          visit: this.visitId && this.visitId > 0 ? this.visitId : undefined,
          ticket:
            this.ticketId && this.ticketId > 0 ? this.ticketId : undefined,
        })
        .then((engineersList) => {
          if (
            isScheduleChange &&
            this.assignedTeam &&
            this.assignedTeam.length > 0
          ) {
            this.filterUnavailableAssignedEngineers(engineersList);
          }
          return engineersList;
        });
    },
  },
  computed: {
    ...mapGetters([
      "vShowCalendar",
      "oneOffSchedule",
      "recurringSchedule",
      "jobLoading",
      "availableTeam",
      "availableTeamStale",
      "assignedTeam",
      "assignedTeamObject",
      "scheduleType",
      "scheduleOutput",
    ]),
    scheduleWatchKey() {
      if (this.scheduleType === "one-off") {
        if (
          !this.oneOffSchedule?.start_date ||
          !this.oneOffSchedule?.end_date ||
          !this.oneOffSchedule?.start_time ||
          !this.oneOffSchedule?.end_time
        ) {
          return "";
        }
        return `${this.oneOffSchedule.start_date} ${this.oneOffSchedule.start_time} - ${this.oneOffSchedule.end_date} ${this.oneOffSchedule.end_time}`;
      }
      if (
        this.scheduleType === "recurring" &&
        this.scheduleOutput &&
        this.scheduleOutput.length > 0
      ) {
        const first = this.scheduleOutput[0];
        const sDate = first.startDate || first.start_date;
        const sTime = first.startTime || first.start_time;
        const eDate = first.endDate || first.end_date;
        const eTime = first.endTime || first.end_time;
        if (!sDate || !eDate || !sTime || !eTime) {
          return "";
        }
        return `${sDate} ${sTime} - ${eDate} ${eTime}`;
      }
      return "";
    },
  },
  components: {
    Dialog,
  },
  created() {
    this.visitId = Number(this.$route?.query?.visit ?? 0);
    this.ticketId = Number(this.$route?.query?.ticket ?? 0);
  },
  mounted() {
    this.getRelatedSkill();
  },
  beforeDestroy() {
    clearTimeout(this.checkScheduleTimeout);
  },
};
</script>

<style scoped>
.assigned-member-card {
  transition: all 0.2s ease-in-out;
  border: 1px solid #e0e6ed !important;
  background-color: #ffffff;
}

.assigned-member-card:hover {
  border-color: #00bcd4 !important;
  box-shadow: 0 4px 12px rgba(0, 188, 212, 0.08);
}

.assigned-member-card.is-team-lead {
  border-left: 4px solid #1976d2 !important;
  background-color: #f4f8fe;
}

.avatar-shadow {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.border-red-light {
  border: 1px solid #ffcdd2 !important;
}

.border-dashed {
  border: 2px dashed #cfd8dc !important;
  background-color: #fafbfc;
}

.empty-team-state {
  transition: all 0.2s ease;
}

.empty-team-state:hover {
  background-color: #f4f9fb;
  border-color: #00bcd4 !important;
}

.remove-btn {
  transition: transform 0.2s ease;
}

.remove-btn:hover {
  transform: scale(1.1);
  background-color: rgba(244, 67, 54, 0.08);
}

.color-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.engineer-table {
  border: 1px solid #e0e6ed;
}

.table-header-style {
  background-color: #f8fafc !important;
  color: #1e293b !important;
  border-bottom: 2px solid #e2e8f0 !important;
}

.table-row-hover {
  transition: background-color 0.15s ease;
}

.table-row-hover:hover {
  background-color: #f1f5f9 !important;
}

.selected-row {
  background-color: #e0f7fa !important;
}

.gap-1 {
  gap: 4px;
}

.gap-2 {
  gap: 8px;
}

.shadow-xs {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
